import { register } from '../component.js';
import 'react';
import 'react/jsx-runtime';

var _socialIcons_yandex = register("yandex", {"color":"#fc3f1d","path":"M0 0v64h64V0Zm18.656 16h5.91l7.248 15.793c2.124 4.604 3.05 6.998 3.05 12.293V48H29.46v-3.223c0-4.374-.507-6.539-2.262-10.314zm21.008 0h5.68L38.51 31.47h-5.586z"});

export { _socialIcons_yandex as default };
